import { render } from "./GameDetails.vue?vue&type=template&id=971878e8"
import script from "./GameDetails.vue?vue&type=script&lang=js"
export * from "./GameDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__